import { useConsent } from './useConsent'

export const useConsentReady: () => boolean = () => {
  const { consentReady } = useConsent()
  return consentReady
}
